export enum LemonSubscriptionStatus {
  ON_TRAIL = "on_trail",
  ACTIVE = "active",
  PAUSED = "paused",
  PAST_DUE = "past_due",
  UNPAID = "unpaid",
  CANCELLED = "cancelled",
  EXPIRED = "expired",
}
